import type { gqlV2 } from '@vrplatform/data';
import { type Maybe, toTitleCase } from '@vrplatform/utils';

import { Badge } from '@vrplatform/components';
import type { DefaultMantineColor } from '@mantine/core';
import type { owner_statement_status_enum } from '@vrplatform/graphql';

type Props = {
  status: Maybe<gqlV2.owner_statement_status_enum>;
};

export const LegacyStatementStatusBadge = ({ status }: Props) => {
  if (!status) return null;

  return (
    <Badge
      color={STATEMENT_STATUS_COLORS[status as owner_statement_status_enum]}
    >
      {toTitleCase(status)}
    </Badge>
  );
};

export const STATEMENT_STATUS_COLORS: Record<
  owner_statement_status_enum,
  DefaultMantineColor
> = {
  draft: 'yellow',
  inReview: 'violet',
  posted: 'cyan',
  published: 'green',
  void: 'gray',
};
